import { findOne } from 'rcd-cpp-workspace/utils/array';
import * as React from 'react';
import { FilterProps } from '../filters';
import './booleanFilter.scss';
import { Op } from '../../../enums/Op';
import { parseCondition } from '../../../utils';
import { Typeahead } from '../../Typeahead/typeahead';

const Booleans = ['True', 'False'];

export const BooleanFilter = ({
  filter,
  field,
  setFilter,
  filters
}: FilterProps) => {
  let conditions = [];
  const curFilter = filter; //findOne(filters, { field: filter.field });
  if (curFilter.conditions) conditions = curFilter.conditions;
  const { op, val } = parseCondition(curFilter.conditions, Op.is);

  return (
    <div className="filter-box boolean-filter">
      <div>{field.name} is&nbsp;</div>
      <div>
        <Typeahead
          value={val === true ? 'True' : val === false ? 'False' : ''}
          options={Booleans}
          showAllByDefault
          includes={() => true}
          onSelect={o =>
            setFilter({ ...curFilter, conditions: [{ [op]: o == 'True' }] })
          }
          onTextChange={t => {
            if (!t) {
              setFilter({ ...curFilter, conditions: [{ [op]: null }] });
            } else if (t?.toLowerCase() == 'true') {
              setFilter({ ...curFilter, conditions: [{ [op]: true }] });
            } else if (t?.toLowerCase() == 'false') {
              setFilter({ ...curFilter, conditions: [{ [op]: false }] });
            }
          }}
        />
      </div>
    </div>
  );
};
